import React, { useEffect, useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import { Tooltip } from "@material-ui/core";
import PregnantWomanIcon from "@material-ui/icons/PregnantWoman";

/**
 * Campanha de saúde e prevenção do mês (calendário "12 meses, 12 cores").
 * Fica no rodapé da barra lateral: cor e símbolo do mês, e as mensagens
 * do mês trocam sozinhas a cada poucos segundos.
 */

// ---- símbolos (SVG simples, 24x24) ----
const Laco = (p) => (
  <svg viewBox="0 0 24 24" {...p}>
    <path
      fill="currentColor"
      d="M12 2c-2.2 0-4 1.8-4 4 0 1.4.6 2.8 1.5 4L4 18.3 6.6 21l5.4-7.2 5.4 7.2 2.6-2.7L14.5 10c.9-1.2 1.5-2.6 1.5-4 0-2.2-1.8-4-4-4zm0 2.2c1 0 1.8.8 1.8 1.8 0 .9-.4 1.8-1 2.7L12 9.8l-.8-1.1c-.6-.9-1-1.8-1-2.7 0-1 .8-1.8 1.8-1.8z"
    />
  </svg>
);
const Gota = (p) => (
  <svg viewBox="0 0 24 24" {...p}>
    <path fill="currentColor" d="M12 2.5S5.5 9.6 5.5 14.5a6.5 6.5 0 0013 0C18.5 9.6 12 2.5 12 2.5z" />
  </svg>
);
const Cerebro = (p) => (
  <svg viewBox="0 0 24 24" {...p}>
    <path
      fill="currentColor"
      d="M9 3a3 3 0 00-3 2.8A3 3 0 003.6 10 3 3 0 004 15.4 3 3 0 007.5 19 2.7 2.7 0 0011 20.5V4.2A3 3 0 009 3zm6 0a3 3 0 013 2.8 3 3 0 012.4 4.2 3 3 0 01-.4 5.4 3 3 0 01-3.5 3.6A2.7 2.7 0 0113 20.5V4.2A3 3 0 0115 3z"
    />
  </svg>
);
const Borboleta = (p) => (
  <svg viewBox="0 0 24 24" {...p}>
    <path fill="currentColor" d="M11.2 8.5C9.6 5.6 6.2 3.6 3.7 4.3 1.5 5 2.4 9.7 6.3 11 2.9 12.1 2.4 16 4.6 17c2.4 1.1 5.4-1.3 6.6-4.2z" />
    <path fill="#f97316" d="M12.8 8.5c1.6-2.9 5-4.9 7.5-4.2 2.2.7 1.3 5.4-2.6 6.7 3.4 1.1 3.9 5 1.7 6-2.4 1.1-5.4-1.3-6.6-4.2z" />
    <rect x="11.3" y="7" width="1.4" height="11" rx=".7" fill="currentColor" />
  </svg>
);
const Capacete = (p) => (
  <svg viewBox="0 0 24 24" {...p}>
    <path fill="currentColor" d="M4 15a8 8 0 0116 0v1H4zM10 6.2a6 6 0 014 0V11h-4zM2 17.2h20v2.3H2z" />
  </svg>
);
const Figado = (p) => (
  <svg viewBox="0 0 24 24" {...p}>
    <path fill="currentColor" d="M2.5 9.5C2.5 6.8 5 5 8.5 5h10c2 0 3 1.2 3 3 0 4.6-4.6 8.8-10.2 9.8-3.2.6-5.3-.8-6.3-3.1-1.6-.4-2.5-2.3-2.5-5.2z" />
  </svg>
);

export const CAMPANHAS = [
  {
    mes: "Janeiro", curtas: ["Janeiro Branco", "Cuide da mente", "Faça pausas", "Peça ajuda"], nome: "Janeiro Branco", tema: "Saúde mental", cor: "#64748b", Icone: Cerebro,
    msgs: ["Cuidar da mente também é cuidar do time.", "Pausas e conversas abertas previnem o esgotamento.", "Pedir ajuda é sinal de força, não de fraqueza."],
  },
  {
    mes: "Fevereiro", curtas: ["Fevereiro Roxo", "Fevereiro Laranja", "Acolha quem tem dor", "Doe medula"], nome: "Fevereiro Roxo e Laranja", tema: "Lúpus, fibromialgia e Alzheimer", cor: "#7c3aed", Icone: Borboleta,
    msgs: ["Conscientização sobre lúpus, fibromialgia e Alzheimer.", "Dor crônica é real: acolha e ajuste a rotina.", "Laranja também lembra a leucemia: doe medula."],
  },
  {
    mes: "Março", curtas: ["Março Azul-Marinho", "Faça o rastreio", "Coma mais fibras", "Previna-se"], nome: "Março Azul-Marinho", tema: "Câncer colorretal", cor: "#1e3a8a", Icone: Laco,
    msgs: ["Prevenção do câncer colorretal.", "A partir dos 45 anos, converse com o médico sobre o rastreio.", "Fibras, água e atividade física ajudam a prevenir."],
  },
  {
    mes: "Abril", curtas: ["Abril Verde", "Use seus EPIs", "Respeite as pausas", "Trabalho seguro"], nome: "Abril Verde", tema: "Segurança no trabalho", cor: "#15803d", Icone: Capacete,
    msgs: ["Segurança no trabalho começa na prevenção.", "Use os EPIs e respeite as pausas.", "Ergonomia também é segurança: ajuste cadeira e tela."],
  },
  {
    mes: "Maio", curtas: ["Maio Amarelo", "Celular no bolso", "Respeite a faixa", "Dirija com calma"], nome: "Maio Amarelo", tema: "Trânsito seguro", cor: "#ca8a04", Icone: Laco,
    msgs: ["No trânsito, a escolha é a vida.", "Celular no trânsito? Só depois de estacionar.", "Respeite o limite de velocidade e a faixa de pedestres."],
  },
  {
    mes: "Junho", curtas: ["Junho Vermelho", "Doe sangue", "Salve 4 vidas", "Vá ao hemocentro"], nome: "Junho Vermelho", tema: "Doação de sangue", cor: "#dc2626", Icone: Gota,
    msgs: ["Doe sangue: uma doação pode salvar até 4 vidas.", "Procure o hemocentro mais perto de você.", "Doar é rápido, seguro e faz muita diferença."],
  },
  {
    mes: "Julho", curtas: ["Julho Amarelo", "Faça o teste", "Vacine-se", "Hepatite tem cura"], nome: "Julho Amarelo", tema: "Hepatites virais", cor: "#ca8a04", Icone: Figado,
    msgs: ["Combate às hepatites virais.", "Teste rápido e vacina estão disponíveis no SUS.", "Hepatite muitas vezes não tem sintomas: faça o teste."],
  },
  {
    mes: "Agosto", curtas: ["Agosto Dourado", "Apoie quem amamenta", "Amamentar é cuidar", "Acolha as mães"], nome: "Agosto Dourado", tema: "Aleitamento materno", cor: "#b7791f", Icone: PregnantWomanIcon, mui: true,
    msgs: ["Incentivo ao aleitamento materno.", "Apoie as mães que voltam ao trabalho.", "Um espaço acolhedor faz diferença para quem amamenta."],
  },
  {
    mes: "Setembro", curtas: ["Setembro Amarelo", "Falar é a solução", "Ouça sem julgar", "CVV: ligue 188"], nome: "Setembro Amarelo", tema: "Prevenção ao suicídio", cor: "#ca8a04", Icone: Laco,
    msgs: ["Falar é a melhor solução. Ouça sem julgar.", "Precisa conversar? CVV: ligue 188 (24h, gratuito).", "Perceba sinais de isolamento e ofereça apoio."],
  },
  {
    mes: "Outubro", curtas: ["Outubro Rosa", "Faça o autoexame", "Agende a mamografia", "Previna-se"], nome: "Outubro Rosa", tema: "Câncer de mama", cor: "#db2777", Icone: Laco,
    msgs: ["Prevenção do câncer de mama.", "Autoconhecimento e mamografia salvam vidas.", "Lembre quem você ama de fazer os exames."],
  },
  {
    mes: "Novembro", curtas: ["Novembro Azul", "Faça os exames", "Cuide-se, homem", "Previna-se"], nome: "Novembro Azul", tema: "Câncer de próstata", cor: "#2563eb", Icone: Laco,
    msgs: ["Prevenção do câncer de próstata.", "A partir dos 50 anos (45 com histórico), faça os exames.", "Cuidar da saúde também é coisa de homem."],
  },
  {
    mes: "Dezembro", curtas: ["Dezembro Vermelho", "Faça o teste", "Use preservativo", "Informação salva"], nome: "Dezembro Vermelho", tema: "HIV/aids", cor: "#dc2626", Icone: Laco,
    msgs: ["Prevenção ao HIV/aids e outras ISTs.", "Teste rápido gratuito no SUS. Prevenir é cuidar.", "Informação combate o preconceito."],
  },
];

const hexRgba = (hex, a) => {
  const n = parseInt(hex.slice(1), 16);
  return `rgba(${(n >> 16) & 255},${(n >> 8) & 255},${n & 255},${a})`;
};

const useStyles = makeStyles((theme) => {
  const escuro = theme.palette.type === "dark";
  return {
    caixa: {
      position: "relative",
      zIndex: 1,
      padding: "10px 12px 12px",
      borderTop: `1px solid ${escuro ? "rgba(148,163,184,0.12)" : "#eef2f2"}`,
    },
    pilula: {
      display: "flex",
      alignItems: "center",
      gap: 10,
      padding: "8px 12px 8px 8px",
      borderRadius: 14,
      border: "1px solid var(--cor35)",
      background: escuro ? "var(--cor15)" : "var(--cor08)",
      cursor: "default",
      overflow: "hidden",
      position: "relative",
      // brilho que atravessa devagar
      "&::after": {
        content: '""',
        position: "absolute",
        top: 0,
        bottom: 0,
        left: 0,
        width: "40%",
        background: "linear-gradient(90deg, transparent, rgba(255,255,255,.35), transparent)",
        animation: "sbVarrer 7s ease-in-out infinite",
        pointerEvents: "none",
      },
    },
    icone: {
      width: 30,
      height: 30,
      borderRadius: 9,
      flexShrink: 0,
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      color: "var(--cor)",
      background: "var(--cor18)",
      animation: "iaCampanhaPulso 3.2s ease-in-out infinite",
      "& svg": { width: 19, height: 19 },
    },
    textos: { minWidth: 0, display: "flex", flexDirection: "column", lineHeight: 1.2 },
    janela: {
      position: "relative",
      flex: 1,
      minWidth: 0,
      height: 20,
      overflow: "hidden",
    },
    frase: {
      position: "absolute",
      left: 0,
      right: 0,
      top: 0,
      fontSize: "0.86rem",
      fontWeight: 800,
      lineHeight: "20px",
      color: escuro ? "#f1f5f9" : "var(--cor)",
      whiteSpace: "nowrap",
      overflow: "hidden",
      textOverflow: "ellipsis",
    },
    fraseEntra: { animation: "iaFraseEntra .38s cubic-bezier(.22,1,.36,1) both" },
    fraseSai: { animation: "iaFraseSai .38s ease-in both" },
    nome: {
      fontSize: "0.84rem",
      fontWeight: 800,
      color: escuro ? "#f1f5f9" : "var(--cor)",
      whiteSpace: "nowrap",
      overflow: "hidden",
      textOverflow: "ellipsis",
    },
    tema: {
      marginTop: 6,
      paddingLeft: 4,
      fontSize: "0.68rem",
      fontWeight: 600,
      color: theme.palette.text.secondary,
      whiteSpace: "nowrap",
      overflow: "hidden",
      textOverflow: "ellipsis",
    },
    mensagem: {
      marginTop: 8,
      minHeight: 32,
      fontSize: "0.72rem",
      lineHeight: 1.35,
      color: theme.palette.text.secondary,
      whiteSpace: "normal",
      transition: "opacity .45s ease, transform .45s ease",
    },
    escondida: { opacity: 0, transform: "translateY(4px)" },
    recolhida: {
      display: "flex",
      justifyContent: "center",
      padding: "10px 0 12px",
      borderTop: `1px solid ${escuro ? "rgba(148,163,184,0.12)" : "#eef2f2"}`,
      position: "relative",
      zIndex: 1,
    },
  };
});

const CampanhaDoMes = ({ recolhida = false }) => {
  const classes = useStyles();
  const c = CAMPANHAS[new Date().getMonth()];
  const frases = c.curtas && c.curtas.length ? c.curtas : [c.nome];
  const [i, setI] = useState(0);
  const [saindo, setSaindo] = useState(false);

  // troca a frase da pilula: a atual sobe e some, a proxima entra por baixo
  useEffect(() => {
    const t = setInterval(() => {
      setSaindo(true);
      setTimeout(() => {
        setI((x) => (x + 1) % frases.length);
        setSaindo(false);
      }, 380);
    }, 3800);
    return () => clearInterval(t);
  }, [frases.length]);

  const vars = {
    "--cor": c.cor,
    "--cor08": hexRgba(c.cor, 0.08),
    "--cor15": hexRgba(c.cor, 0.15),
    "--cor18": hexRgba(c.cor, 0.16),
    "--cor35": hexRgba(c.cor, 0.35),
  };
  const Icone = c.Icone;
  const dica = (
    <div style={{ maxWidth: 240 }}>
      <b>{c.nome}</b> — {c.tema}
      <ul style={{ margin: "6px 0 0", paddingLeft: 16 }}>
        {c.msgs.map((m) => (
          <li key={m}>{m}</li>
        ))}
      </ul>
    </div>
  );

  if (recolhida) {
    return (
      <div className={classes.recolhida} style={vars}>
        <Tooltip title={dica} placement="right" arrow>
          <span className={classes.icone}>
            <Icone />
          </span>
        </Tooltip>
      </div>
    );
  }

  return (
    <div className={classes.caixa} style={vars}>
      <Tooltip title={dica} placement="top" arrow>
        <div className={classes.pilula}>
          <span className={classes.icone}>
            <Icone />
          </span>
          <span className={classes.janela}>
            <span key={i} className={`${classes.frase} ${saindo ? classes.fraseSai : classes.fraseEntra}`}>
              {frases[i]}
            </span>
          </span>
        </div>
      </Tooltip>
      <div className={classes.tema}>{c.tema}</div>
    </div>
  );
};

export default CampanhaDoMes;
